<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-if="!modoEdicao">
        <div class="form-edit-page" style="display: flex; gap: 10px; align-items: end;">
            <div class="form-item">
                <label class="label-caption" for="nmPesquisa">Nome Pesquisa</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="80" v-uppercase />
            </div>
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="showModalCpf=true" />
            <button type="button" class="buttom-icon--close" @click="closePage" />
        </div>

        <div v-if="lsDados.length>0" class="margin-top10 table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Nome</th>
                        <th>Apelido</th>
                        <th>Nascimento</th>
                        <th>Fone</th>
                        <th>Empresa</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" @click="editarCadastro(obj)">
                        <td class="col-width-integer right">{{ obj.cdpessoa }}</td>
                        <td>{{ obj.nmpessoa }}</td>
                        <td class="col-width-char20">{{ obj.apelido }}</td>
                        <td class="col-width-char15 center">{{ Funcoes.formatDateFromJson(obj.dtnascimento) }}</td>
                        <td class="col-width-char15 center">{{ obj.celular }}</td>
                        <td class="col-width-char40">{{ obj.empresa_nome }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <CpfModal
        v-if="showModalCpf"
        :allowSemCpf="true"
        @close="showModalCpf = false"
        @cpfSubmitted="novoCadastro"/>

    
    <div v-if="modoEdicao">
        <GabinetePessoaEditPage :idEdicao="idEdicao" :cpfNovo="cpfNovo" @close="modoEdicao = false" @salvo="lerDados" />
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { genericGet, genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import { Funcoes } from '@/funcoes/utils';
import CpfModal from '@/components/modals/CpfModal.vue';
import GabinetePessoaEditPage from '../formularios/GabinetePessoaEditPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit=defineEmits(['close'])

const cpfNovo = ref(null);
const idEdicao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(null);
const nmPesquisa = ref('');

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showModalCpf = ref(false);
const showPagination = ref(false);

const closePage = () =>{emit('close');};

const editarCadastro = (obj) => {
    idEdicao.value = obj.id;
    modoEdicao.value = true;
};

const lerDados = async() => {
    try{
        isLoading.value = true;
        const dados = {
            idmunicipio: globalStore.idmunicipio, 
            nmpesquisar: nmPesquisa.value};
        const req = await genericPost('/listas/gabinete_pessoas', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

const novoCadastro = async(value) => {
    showModalCpf.value=false;
    if (value === null) return;
    if (value===''){
        idEdicao.value=0;
        cpfNovo.value='';
    }else{
        try{
            isLoading.value=true;
            const req = await genericGet('/cad/gabinete_pessoa/from_cpfcnpj', {
                idmunicipio: globalStore.idmunicipio,
                cpfcnpj: value});
            if (req.length===0){idEdicao.value=0; cpfNovo.value=value;}else{idEdicao.value=req[0].id}
        } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
        } finally {isLoading.value = false;}
    }
    modoEdicao.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}
</script>
